// extracted by mini-css-extract-plugin
export default {"Container":"Service_Container__+P2xw"};